
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-448b9a44&scoped=true!./GoogleBtn.css")

var Component = require("/quotes-front/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./GoogleBtn.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-448b9a44!./../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./GoogleBtn.pug"),
  /* scopeId */
  "data-v-448b9a44",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleBtn/GoogleBtn.vue
// module id = 251
// module chunks = 2